var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.425 0.486001C22.2075 2.421 19.17 4.8645 15.84 8.19C13.644 10.3815 12.051 12.1635 10.008 14.715C9.37349 15.507 8.01899 17.2845 7.65449 17.8065C7.54649 17.964 7.44299 18.09 7.42949 18.09C7.41599 18.09 5.93549 17.262 4.14449 16.2495L0.886493 14.4045L0.530993 14.832C0.337493 15.066 0.179993 15.282 0.179993 15.3045C0.179993 15.327 2.06549 17.5365 4.36499 20.205L8.55449 25.065H8.86499H9.17999L9.69299 24.039C13.491 16.524 17.1855 11.0565 22.077 5.715C23.0265 4.68 24.9615 2.736 26.0235 1.755C26.4375 1.3725 26.775 1.044 26.775 1.017C26.775 0.972001 26.136 0.0945009 26.1 0.0945009C26.0865 0.0945009 25.785 0.270001 25.425 0.486001Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 25.065,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick-icon.9adbe5e50a5546ce394195159b7595b2.svg";
export { ForwardRef as ReactComponent };